<template>
  <div class="product-list" v-if="data.length">
    <div class="suggest" v-if="suggest">
      <p >没找到"{{keys}}"的搜索结果"</p>
      <p>为你推荐"{{suggest.keyword}}"的相关商品</p>
    </div>
    <simple-product
      v-if="data.length"
      :sdk="sdk"
      :env="env"
      :index="index"
      :searchKey="keys"
      v-for="(item, index) in data"
      :data="item"
      :class="{
        'no-margin': (index + 1) % 2 === 0
      }"
      @click="trackData(index)" />
  </div>
</template>

<script>
import simpleProduct from '@/components/simple-product-new'
import track from '@/track'

import {
  getEnv
} from '@/sdk'


export default {
  components: {
    simpleProduct
  },

  props: ['data', 'keys', 'suggest'],

  data () {
    return {
      list: null,
      sdk: null,
      env: 'm-web'
    }
  },

  created() {
    getEnv()
    .then(sdk => {
      sdk.init({
        vue: this
      })
      this.sdk = sdk
      this.env = sdk.adapter.env
    })
  },
  
  methods: {
    goPro(pid) {
      if(this.enable) {
        return
      }
      location.href = `/product/${pid}`
    },

    trackData (index) {
      track({
        name: 'click-result',
        attrs: {
          index: index
        },
        wait: true
      })
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// list.vue?6aa3e1cc